/**
 * Product tile mobile carousel - Swiper.js
 * Mobile-only, loopable carousel with scrollbar. Respects OUTFIT/PRODUCT view toggle.
 */
(function () {
  const MQ = window.matchMedia('(max-width: 991px)');
  const swiperInstances = [];

  function getInitialView() {
    const forceEl = document.querySelector('[data-force-thumbnail-view]');
    const force = forceEl ? forceEl.getAttribute('data-force-thumbnail-view') : null;
    if (force === 'outfit' || force === 'product') return force;
    try {
      const cookie = document.cookie.split('; ').find(function (c) {
        return c.indexOf('open-modal=') === 0;
      });
      return cookie ? cookie.split('=')[1] : 'outfit';
    } catch (e) {
      return 'outfit';
    }
  }

  function slideTypeMatchesView(slideType, view) {
    if (!slideType) return false;
    if (view === 'product') {
      return slideType.indexOf('product') !== -1;
    }
    return slideType.indexOf('outfit') !== -1;
  }

  function getStartIndex(container, view) {
    const slides = container.querySelectorAll('.swiper-slide');
    for (let i = 0; i < slides.length; i++) {
      const slideType = slides[i].getAttribute('data-slide-type');
      if (slideTypeMatchesView(slideType, view)) return i;
    }
    return 0;
  }

  function initCarousels() {
    if (!MQ.matches) return;

    document.querySelectorAll('.product-tile-swiper').forEach(function (el) {
      if (el.swiper) return;

      const slides = el.querySelectorAll('.swiper-slide');
      if (slides.length <= 1) return;

      const view = getInitialView();
      const startIndex = getStartIndex(el, view);

      const scrollbarEl = el.querySelector('.swiper-scrollbar');
      const sw = new window.Swiper(el, {
        loop: true,
        slidesPerView: 1,
        initialSlide: startIndex,
        threshold: 10,
        touchAngle: 30,
        scrollbar: scrollbarEl
          ? {
              el: scrollbarEl,
              draggable: true
            }
          : false
      });

      swiperInstances.push(sw);
    });
  }

  function destroyCarousels() {
    swiperInstances.forEach(function (sw) {
      try {
        sw.destroy(true, true);
      } catch (e) {
        /* ignore */
      }
    });
    swiperInstances.length = 0;
  }

  function onViewToggle(view) {
    swiperInstances.forEach(function (sw) {
      const slides = sw.el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
      for (let i = 0; i < slides.length; i++) {
        const slideType = slides[i].getAttribute('data-slide-type');
        if (slideTypeMatchesView(slideType, view)) {
          sw.slideToLoop(i, 0);
          break;
        }
      }
    });
  }

  function reinit() {
    destroyCarousels();
    if (MQ.matches) {
      setTimeout(initCarousels, 0);
    }
  }

  MQ.addEventListener('change', function (e) {
    if (e.matches) initCarousels();
    else destroyCarousels();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }

  window.productTileCarousel = {
    onViewToggle: onViewToggle,
    reinit: reinit
  };
})();
